import { Link } from "react-router-dom";
import ReportsData from "./ReportsData";
import AddNewReport from "./AddNewReport";
import { useEffect, useState } from "react";
import { getSavedReportsSuccess, resetReportsState, start } from "../../store/slices/ReportsSlice";
import { useDispatch } from "react-redux";
import fetchApi from "../../services/fetch-data.service";
import Permission from "../RoleManagement/Permission";

const Reports = () => {
    const dispatch = useDispatch();
    const [modalShow, setModalShow] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetchApi(`reports/internal/GetSavedReport`);
                if (res.data && res.data.length > 0) {
                    dispatch(getSavedReportsSuccess(res.data));
                } else {
                    dispatch(resetReportsState());
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [dispatch]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 ">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">Reports</h1>
                </div>

                <nav>
                    <div className="row">
                        <div className="col-sm-12 d-flex justify-content-end title-bg mb-3">
                            <div className="buttons-left">
                                <div className="col-sm-10 position-relative">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                        className="form-control"
                                    />
                                    <span className="fa fa-search department-search-icon"></span>
                                </div>
                            </div>

                            <div className='buttons-right'>
                                <Permission access={"/reportform"}>
                                    <Link variant="primary">
                                        <button className='btn btn-primary btn-add' onClick={() => setModalShow(true)}>
                                            <i className="fa-regular fa-square-plus"></i> CREATE NEW REPORT
                                        </button>
                                    </Link>
                                </Permission>
                            </div>
                            <AddNewReport
                                show={modalShow}
                                onHide={() => setModalShow(false)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <table className="table reports-details">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th style={{paddingLeft:"40px"}}>Date Created</th>
                                    <th>Creator</th>
                                    <th>Reporting Period</th>
                                  {/*  <th style={{paddingLeft:"50px"}}>Status</th>*/}
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ReportsData searchTerm={searchTerm} />
                            </tbody>
                        </table>
                    </div>
                </nav>
            </main>
        </>
    );
};

export default Reports;